import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatToolbarModule } from '@angular/material/toolbar';
import { TranslateModule } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { User } from 'src/app/interfaces/api/user';
import { UserService } from 'src/app/services/api/users/user.service';

@Component({
    selector: 'app-edit-email',
    templateUrl: './edit-email.component.html',
    styleUrls: ['./edit-email.component.scss'],
    imports: [
        MatToolbarModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatIconModule,
        MatDialogModule,
        TranslateModule,
        MatInputModule,
        MatButtonModule,
        CommonModule
    ]
})
export class EditEmailComponent implements OnInit, OnDestroy {
  pwdForm: any;
  destroy$ = new Subject<void>();

  constructor(private fb: FormBuilder, private userService: UserService, @Inject(MAT_DIALOG_DATA) private data: any, public dialog: MatDialog) { }

  ngOnInit(): void {
    this.pwdForm = this.fb.group({
      password: ['', Validators.required]
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  async verifPwd() {
    if (this.pwdForm.status == 'INVALID') {
      return;
    }

    this.userService.verifyUserByPassword({ email: this.data.email, password: this.pwdForm.value.password }).pipe(takeUntil(this.destroy$)).subscribe((user: User) => {
      if (user == null) { 
        this.pwdForm.controls['password'].setErrors({ incorrect: true });
      }
      else {       
        this.dialog.closeAll();
      }
    })

  }

}
